export default __webpack_public_path__ + "static/media/FondoNegro.6d6f3264.jpg";